import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';
import { Notification, NotificationData } from './notification.model';

export class DemographicNotification extends Notification {
  constructor(
    data: NotificationData,
    private readonly translateService: TranslateService,
  ) {
    super(data);
    this.actionName = this.translateService.instant('view_access');
    this.actionRequired = !this.readDate;
    const requestDate = DateTime.fromISO(data?.demographicRequest?.requested_timestamp);
    this.description = this.translateService.instant('demographic_request_description', {
      doctor: data?.demographicRequest?.doctor_name ?? this.translateService.instant('a_practitioner'),
      time: requestDate.toFormat('HH:mm'),
      date: requestDate.toFormat('cccc, dd LLLL'),
    });
  }
}
